import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import history from '../../libs/history';
import createLink from "../../libs/createLink";

import {fetchForums} from "../../creators/forums";

import {Button} from "./Button";
import {fetchForumsListMove} from "../../creators/forums.listMove";

class MoveForum extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            forums: [],
            currentForum: 0,
        };
        this.subForums = this.subForums.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.props.fetchForumsListMove();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.forums !== this.props.forums) {
            this.subForums(nextProps.forums)
        }
    }

    subSubForums(forums, lvl = 0) {
        let newSubForums = [];
        if (forums) {
            forums.forEach((item) => {
                let isSubForum = (item.childrens.length >= 1);
                newSubForums.push({
                    ...item,
                    isActive: !isSubForum,
                    name: `|${"--".repeat(lvl)} ${item.name}`,
                });
                if (isSubForum) {
                    let sub = this.subSubForums(item.childrens, (lvl + 1));
                    newSubForums = [...newSubForums, ...sub];
                }
            });
        }
        return newSubForums;
    }

    subForums(forums, lvl = 0) {
        if (!forums) {
            forums = [];
        }
        let newForums = [];
        forums.forEach((item) => {
            newForums.push({...item, isActive: false});
            if (item.childrens) {
                let sub = this.subSubForums(item.childrens, (lvl + 1));
                newForums = [...newForums, ...sub];
            }
        });
        this.setState({forums: newForums})
    }

    onSubmit() {
        let forum = this.state.forums.filter(item => item._id === this.state.currentForum);
        this.props.handleMoveTopic(forum[0]._id);
        history.push(createLink("forumCategory", {
            category : {slug : forum[0] ? forum[0].slug : "", _id : forum[0]._id}
        }));
    }

    render() {
        return (
            <div id="shift" className={"modal-container"}>
                <div className={"modal-topline"}>
                    <div>Déplacer votre sujet : {this.props.title}</div>
                </div>
                <div className={"modal-body"}>
                    <select className={"full"} onChange={(event) => this.setState({currentForum: event.target.value})}
                            value={this.state.currentForum}>
                        <option disabled value="0">Déplacer vers :</option>
                        {this.state.forums && this.state.forums.map((item, index) => <option key={index}
                                                                                             value={item._id}
                                                                                             disabled={!item.isActive}>{item.name}</option>)}

                    </select>
                </div>
                <div className={"modal-baseline"}>
                    <Button size={"small"}
                            btnStyle={"grey"}
                            onClick={() => this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button size={"small"}
                            btnStyle={"primary-reverse"}
                            onClick={() => this.onSubmit()}
                            content={"Valider"}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        forums: state.forumsListMove.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForums,
    fetchForumsListMove
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(MoveForum);